// The MIT License (MIT)
//
// Copyright (c) 2020 The Prometheus Authors
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
import { AggregateExpr, BinaryExpr, Expr, FunctionCall, MatrixSelector, NumberLiteral, OffsetExpr, ParenExpr, StepInvariantExpr, StringLiteral, SubqueryExpr, UnaryExpr, VectorSelector, } from 'lezer-promql';
import { walkThrough } from './path-finder';
import { getFunction, ValueType } from '../types/function';
// Based on https://github.com/prometheus/prometheus/blob/d668a7efe3107dbdcc67bf4e9f12430ed8e2b396/promql/parser/ast.go#L191
export function getType(node) {
    var _a;
    if (!node) {
        return ValueType.none;
    }
    switch (node.type.id) {
        case Expr:
            return getType(node.firstChild);
        case AggregateExpr:
            return ValueType.vector;
        case VectorSelector:
            return ValueType.vector;
        case OffsetExpr:
            return getType(node.firstChild);
        case StringLiteral:
            return ValueType.string;
        case NumberLiteral:
            return ValueType.scalar;
        case MatrixSelector:
            return ValueType.matrix;
        case SubqueryExpr:
            return ValueType.matrix;
        case ParenExpr:
            return getType(walkThrough(node, Expr));
        case UnaryExpr:
            return getType(walkThrough(node, Expr));
        case BinaryExpr:
            const lt = getType(node.firstChild);
            const rt = getType(node.lastChild);
            if (lt === ValueType.scalar && rt === ValueType.scalar) {
                return ValueType.scalar;
            }
            return ValueType.vector;
        case FunctionCall:
            const funcNode = (_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.firstChild;
            if (!funcNode) {
                return ValueType.none;
            }
            return getFunction(funcNode.type.id).returnType;
        case StepInvariantExpr:
            return getType(walkThrough(node, Expr));
        default:
            return ValueType.none;
    }
}
//# sourceMappingURL=type.js.map